// src/Pages/Owner/OwnerDashboardPage/OwnerDashboardPage.jsx

import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import './OwnerDashboardPage.css';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logout } from '../../../store/slices/ownerAuthSlice';
import ownerAPI from '../../../services/ownerApi';
import OwnerSidebar from '../../../Components/OwnerSidebar/OwnerSidebar';


export default function OwnerDashboardPage() {
  const [club, setClub] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchClub = async () => {
      const token = localStorage.getItem('ownerToken');
      if (!token) {
        navigate('/owner/login');
        return;
      }
      try {
        const clubData = await ownerAPI.getMyClub();
        setClub(clubData);
      } catch (err) {
        console.error('❌ Club fetch failed:', err);
        setError('클럽 정보를 불러오지 못했습니다.');
        if (err.response?.status === 401) {
          dispatch(logout());
          navigate('/owner/login');
        }
      }
    };
    fetchClub();
  }, [navigate, dispatch]);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/owner/login');
  };

  const dummyVisitData = [
    { date: '04-01', visitors: 4 },
    { date: '04-02', visitors: 9 },
    { date: '04-03', visitors: 6 },
    { date: '04-04', visitors: 13 },
    { date: '04-05', visitors: 7 },
    { date: '04-06', visitors: 11 },
  ];

  return (
    <div className="dashboard-wrapper">
    <OwnerSidebar />  


      <main className="dashboard-main">
        <div className="dashboard-header">
          <h1>관리자 대시보드</h1>
          <button onClick={handleLogout}>로그아웃</button>
        </div>

        {error && <p className="error-text">{error}</p>}
        <div className="dashboard-grid">

        <section className="dashboard-section">
          <h2>방문자 통계</h2>
          <ResponsiveContainer width="100%" height={250}>
          <LineChart data={dummyVisitData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="visitors" stroke="#8884d8" activeDot={{ r: 8 }} />
            </LineChart>
          </ResponsiveContainer>
        </section>

        <section
            className="dashboard-section clickable"
            onClick={() => navigate('/owner/edit')}
          >
          <h2>클럽 정보</h2>
          {club ? (
            <div>
              <p><strong>클럽명:</strong> {club.name}</p>
              <p><strong>주소:</strong> {club.address}</p>
              <p><strong>소개:</strong> {club.description}</p>
            </div>
          ) : (
            <p>클럽 정보를 불러오는 중...</p>
          )}
        </section>

        <section className="dashboard-section">
          <h2>최근 문의</h2>
          <ul>
            <li>[입력중] 예약 관련 문의 - 2024-04-20</li>
            <li>[입력중] 입장 가능 시간 문의 - 2024-04-18</li>
          </ul>
        </section>

        <section className="dashboard-section">
          <h2>리뷰</h2>
          <ul>
            <li>👍 분위기 좋았어요! - 사용자1</li>
            <li>💬 음악이 좀 더 다양했으면 좋겠어요 - 사용자2</li>
          </ul>
        </section>
        </div>
      </main>
    </div>
    
  );
}
